import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a72a8484"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-100 w-100" }
const _hoisted_2 = { class: "adminlbl" }
const _hoisted_3 = {
  class: "display-flex margin-top",
  style: {"height":"calc(100% - 20px)"}
}
const _hoisted_4 = { class: "news-table-div" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "m-0 p-0 news-table-title" }, "What's New", -1 /* HOISTED */))
const _hoisted_6 = { class: "scroll-table news_table" }
const _hoisted_7 = {
  class: "table m-0",
  rules: "groups",
  style: {"border":"none !important"}
}
const _hoisted_8 = { class: "subject_td" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "text-center",
  style: {"font-style":"italic"}
}, "No data.", -1 /* HOISTED */))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "backNo" }, "Back Number >>", -1 /* HOISTED */))
const _hoisted_14 = { class: "faq-table-div margin-top-50" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "m-0 p-0 faq-table-title" }, "Display FAQ", -1 /* HOISTED */))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-search searchicon" }, null, -1 /* HOISTED */))
const _hoisted_17 = { class: "scroll-table faq_table" }
const _hoisted_18 = {
  class: "table m-0",
  rules: "groups",
  style: {"border":"none !important"}
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "width-10" }, "■", -1 /* HOISTED */))
const _hoisted_20 = { class: "subject_td" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { key: 0 }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "text-center",
  style: {"font-style":"italic"}
}, "No data.", -1 /* HOISTED */))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "backNo" }, "All FAQs >>", -1 /* HOISTED */))
const _hoisted_26 = {
  class: "modal fade",
  id: "showModal",
  tabindex: "-1",
  "aria-labelledby": "showModalLabel",
  "aria-hidden": "true"
}
const _hoisted_27 = { class: "modal-dialog modal-dialog-scrollable modal-lg" }
const _hoisted_28 = { class: "modal-content" }
const _hoisted_29 = { class: "modal-header" }
const _hoisted_30 = {
  class: "modal-title",
  id: "showModalLabel"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1 /* HOISTED */))
const _hoisted_32 = {
  class: "modal-body",
  id: "modal-body",
  style: {"text-align":"left"}
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-secondary",
    "data-bs-dismiss": "modal"
  }, " Close ")
], -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Loading"], { isLoading: $setup.isLoading }, null, 8 /* PROPS */, ["isLoading"]),
    _createVNode($setup["Alert"], {
      alertMessage: $setup.alertMessage,
      alertState: $setup.alertState
    }, null, 8 /* PROPS */, ["alertMessage", "alertState"]),
    _createElementVNode("div", null, [
      _createElementVNode("label", _hoisted_2, "Your Administrator : " + _toDisplayString($setup.administratorAddress), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createCommentVNode(" News Table Start "),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("table", _hoisted_7, [
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.newsInfo, (info, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", {
                    class: "width-10",
                    style: _normalizeStyle({ color: info.importance.color })
                  }, " ■ ", 4 /* STYLE */),
                  _createElementVNode("td", {
                    class: "news_date_td",
                    style: _normalizeStyle({ color: info.importance.color })
                  }, _toDisplayString(info.startDate), 5 /* TEXT, STYLE */),
                  _createElementVNode("td", _hoisted_8, [
                    _createElementVNode("a", {
                      href: "#",
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#showModal",
                      onClick: ($event: any) => ($setup.modalShow(index, 'News')),
                      style: _normalizeStyle({ color: info.importance.color })
                    }, _toDisplayString(info.Subject), 13 /* TEXT, STYLE, PROPS */, _hoisted_9)
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */)),
              ($setup.newsInfo.length == 0 && $setup.getData)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_10, _hoisted_12))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ]),
        _createVNode(_component_router_link, { to: "/newsbackno" }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _createCommentVNode(" News Table End "),
      _createCommentVNode(" FAQ Table Start "),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _hoisted_16,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "search",
          name: "search",
          placeholder: " Search...",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.search) = $event)),
          onKeyup: $setup.changeEvent
        }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
          [_vModelText, $setup.search]
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("table", _hoisted_18, [
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.faqInfo, (info, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _hoisted_19,
                  _createElementVNode("td", _hoisted_20, [
                    _createElementVNode("a", {
                      href: "#",
                      onClick: ($event: any) => ($setup.showFaq(info.Content))
                    }, _toDisplayString(info.Subject), 9 /* TEXT, PROPS */, _hoisted_21)
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */)),
              ($setup.faqInfo.length == 0 && $setup.getData)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_22, _hoisted_24))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ]),
        _createVNode(_component_router_link, { to: "/FAQbackno" }, {
          default: _withCtx(() => [
            _hoisted_25
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _createCommentVNode(" FAQ Table End ")
    ]),
    _createCommentVNode(" Modal "),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("h5", _hoisted_30, _toDisplayString($setup.modalSubject[0]), 1 /* TEXT */),
            _hoisted_31
          ]),
          _createElementVNode("div", _hoisted_32, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.modalBody, (info, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                _createTextVNode(_toDisplayString(info) + " ", 1 /* TEXT */),
                _hoisted_33
              ], 64 /* STABLE_FRAGMENT */))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _hoisted_34
        ])
      ])
    ])
  ]))
}